const SelectService = (state) => state.SelectService
const Rebook = (state) => state.Rebook
const FlightHistory = (state) => state.FlightHistory
const PaxsGroup = (state) => state.PaxsGroup

export default {
  SelectService,
  Rebook,
  FlightHistory,
  PaxsGroup
}
